<template>

    <div @click="closeAutocomplete()">

        <div class="autocomplete-bg" :class="{ 'active' : showResults }"></div>

        <div class="search-container" :class="[bookingStore.view, { 'has-autocomplete' : showResults }]">
            <div class="w-100 pt-5">
                <div class="container-fluid">
                    <div class="position-relative">
                        <input type="search"
                               class="form-control search-field"
                               name="q"
                               id="searchField"
                               :aria-label="search_placeholder"
                               :placeholder="search_placeholder"
                               enterkeyhint="search"
                               inputmode="search"
                               @focus="showAutocomplete()"
                               @keyup="showAutocomplete()"
                               v-model="text"
                               autocomplete="off"
                               @click.stop
                        />
                        <div class="clear-text" :class="{ 'active' : text !== '' }" @click="clearText()"></div>
                    </div>

                    <div :class="{ 'd-none' : bookingStore.productAreas.length <= 1 || bookingStore.view === 'times' }" v-if="app_version === 'customer_card'" @click.stop>
                        <div class="btn btn-filter me-2 mt-2"
                             :class="{ 'active' : productArea === product_area}"
                             :key="'product_area'+product_area"
                             @click="setProductArea(product_area)"
                             v-for="product_area in bookingStore.productAreas"
                        >
                            {{ productAreaName(product_area) }}
                        </div>
                    </div>

                </div>

                <div class="search-autocomplete" v-if="showResults">

                    <div class="container-fluid" @click="closeAutocomplete()">
                        <div class="search-autocomplete-body" @click.stop>
                            <div class="search-autocomplete-row" v-if="resultPlaces.length === 0 && resultClinics.length === 0 && text">
                                Inga resultat
                            </div>
                            <div class="search-autocomplete-row" :key="'place'+index" v-for="(place, index) in resultPlaces" @click="goToPlace(place)">
                                <div class="d-flex">
                                    <div class="d-flex align-items-center">
                                        <div class="portrait-wrapper small place"></div>
                                    </div>
                                    <div class="pt-1">
                                        <span style=" font-size: 1.1rem;" v-html="formatPlace(place.text.toString(),true)"></span><br>
                                        <span style="color:#999; font-size: 0.925rem;">Adress</span>
                                    </div>
                                </div>
                            </div>
                            <div class="search-autocomplete-row" :key="'clinic'+index" v-for="(clinic, index) in resultClinics" @click="goToClinic(clinic)">

                                <!-- Mottagning -->
                                <div class="d-flex" v-if="clinic.checkbox_multiple_clinics || clinic.practitioners.length > 1">
                                    <div class="d-flex align-items-center">
                                        <div class="portrait-wrapper small"></div>
                                    </div>
                                    <div class="pt-1">
                                        <span style=" font-size: 1.1rem;" v-html="boldSearchString(clinic.card_name_clinic)"></span><br>
                                        <span style="color:#999; font-size: 0.925rem;" v-html="boldSearchString(clinic.address.street+', '+clinic.address.city)"></span><br>
                                        <span style="color:#999; font-size: 0.925rem;">
                                            <span v-for="(practitioner, index2) in clinic.practitioners" v-if="practitioner.is_clinic != 1"><span v-if="index2 != 0">, </span><span v-html="boldSearchString(practitioner.name)"></span></span>
                                        </span>
                                    </div>
                                </div>

                                <!-- Enskild massör med namn -->
                                <div class="d-flex" v-else>
                                    <div class="d-flex align-items-center">
                                        <div class="portrait-wrapper small" v-for="practitioner in clinic.practitioners"><img :src="practitioner.thumb_url" class="portrait" v-if="practitioner.thumb_url" /></div>
                                    </div>
                                    <div class="pt-1" v-for="practitioner in clinic.practitioners">
                                        <span style=" font-size: 1.1rem;" v-html="boldSearchString(practitioner.name)"></span><br>
                                        <span style="color:#999; font-size: 0.925rem;" v-html="boldSearchString(clinic.address.street+', '+clinic.address.city)"></span>
                                    </div>
                                </div>

                                

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapStores } from 'pinia'
import { useBookingStore } from '../../stores/bookingStore'
import axios from 'axios'

export default {
    data () {
        return {
            text: '',
            showResults: false,

            resultClinics: [],
            resultPlaces: []
        }
    },
    computed: {
        ...mapStores(useBookingStore),
        ...mapState(useBookingStore, {
            productArea: state => state.productArea,
            singleResultClinic: state => state.singleResultClinic
        }),
        search_placeholder () {
            if (this.productArea === 2) {
                return 'Sök adress eller tränare...'
            }
            return 'Sök adress eller massör...'
        }
    },
    watch: {
        text () {
            this.search()

            if (this.text == '') {
                this.bookingStore.hasSearch = null
                if (this.bookingStore.singleResultClinic) {
                    this.bookingStore.singleResultClinic = null
                }
            }
        }
    },
    methods: {
        setProductArea (productArea) {
            this.bookingStore.$patch({
                productArea: productArea
            })
        },

        async search () {
            if (!this.text) {
                return
            }

            const [result1, result2] = await Promise.all([this.searchBackend(), this.searchFrontend()])

            this.resultClinics = result1
            this.resultPlaces = result2

            console.log('search booth functions ansync')
            console.log(result1)
            console.log(result2)
        },

        async searchBackend () {
            return await axios.post('/booking/searchNew', { text: this.text, productArea: this.productArea })
                .then(response => {
                    console.log('search complete')
                    console.log(response.data)

                    return response.data
                })
        },

        async searchFrontend () {
            const { AutocompleteSessionToken, AutocompleteSuggestion } = await google.maps.importLibrary('places')

            const request = {
                input: this.text,
                includedPrimaryTypes: ['street_address', 'route', 'postal_town', 'administrative_area_level_1', 'administrative_area_level_2'],
                language: 'sv-SE',
                includedRegionCodes: ['se']
            }

            // Create a session token.
            const token = new AutocompleteSessionToken()
            // Add the token to the request.
            request.sessionToken = token
            // Fetch autocomplete suggestions.
            const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions(request)

            const hits = []

            for (const suggestion of suggestions) {
                const placePrediction = suggestion.placePrediction

                hits.push(placePrediction)
            }

            // const place = suggestions[0].placePrediction.toPlace() // Get first predicted place.
            // await place.fetchFields({
            //     fields: ['displayName', 'formattedAddress', 'geometry']
            // })

            return Promise.resolve(hits)
        },

        async goToPlace (selected) {
            const place = selected.toPlace()

            await place.fetchFields({
                fields: ['location', 'viewport', 'types']
            })

            // console.log('geometry geometry geometry')
            // console.log(place.types)

            // const center = { lat: place.location.lat(), lng: place.location.lng() }

            this.bookingStore.bounds = [
                place.viewport.getNorthEast(),
                place.viewport.getSouthWest()
            ]
            this.bookingStore.boundsTypes = place.types

            // this.bookingStore.getBounds(center)

            this.showResults = false

            this.text = this.formatPlace(selected.text.toString(), false)

            this.bookingStore.trigTimeHighlight = true

            this.bookingStore.hasSearch = 'address'

            this.bookingStore.autocompleteSelectedPhrase = this.text

            this.matomoTrackEvent('Booking', 'Search address', this.text)
            
        },

        goToClinic (clinic) {
            this.bookingStore.singleResultClinic = clinic
            this.showResults = false

            this.$router.push({ name: 'modal-clinic', params: { clinic: clinic.id } })

            if (this.bookingStore.singleResultClinic.practitioners && this.bookingStore.singleResultClinic.practitioners.length < 2) {
                this.bookingStore.singleResultClinic.practitioners.forEach(practitioner => {
                    if(this.bookingStore.singleResultClinic.checkbox_multiple_clinics === true){
                        this.text = this.bookingStore.singleResultClinic.card_name_clinic
                    }else{
                        this.text = practitioner.name
                    }
                    
                })
            } else {
                this.text = this.bookingStore.singleResultClinic.card_name_clinic
            }

            this.bookingStore.hasSearch = 'clinic'

            this.bookingStore.autocompleteSelectedPhrase = this.text

            this.matomoTrackEvent('Booking', 'Search partner', this.text)

        },
        formatPlace (place, bold) {
            const formattedPlace = place.replace(/, Sverige$/, '')
            if (bold) {
                return this.boldSearchString(formattedPlace)
            }
            return formattedPlace
        },
        resetSingleResultClinic () {
            this.bookingStore.singleResultClinic = null
        },
        clearText () {
            this.text = ''
            this.closeAutocomplete()
            this.bookingStore.hasSearch = null

            if (this.bookingStore.singleResultClinic) {
                this.bookingStore.singleResultClinic = null
            }
        },
        showAutocomplete () {
            if (this.text !== '') {
                this.showResults = true
            } else {
                this.showResults = false
            }
        },
        closeAutocomplete () {
            this.showResults = false
        },
        boldSearchString(string) {
            if (!this.text || !string) {
                return string
            }

            const escapedText = this.text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
            const regex = new RegExp(escapedText, 'gi')

            return string.replace(regex, '<b>$&</b>')
        },
        firstName (string) {
            const arr = string.split(' ')
            return arr[0]
        }
    }
}
</script>
